import React, { useEffect, useState } from "react";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import ConfiguratorRoot from "../../examples/Configurator/ConfiguratorRoot";
import PropTypes from "prop-types";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import useApi from "../../components/Utils/api";
import toast from "react-hot-toast";
import { useMaterialUIController } from "../../context";
import { FormControl, InputLabel, Select } from "@mui/material";
import { Controller } from "react-hook-form";
import MenuItem from "@mui/material/MenuItem";

function NewUser({ openConfigurator, setOpenConfigurator }) {
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const [updatedUser, setUpdatedUser] = useState({
    firstName: "",
    lastName: "",
    mobileNo: "",
    password: "",
    emailId: "",
    dept: "",
    userId: "",
    countryCode: "91",
    role: "",
  });
  const api = useApi();
  const newUserFormHandler = (form) => {
    form.preventDefault();
    if (!isValidUserId) {
      toast.error("Username must be 1–9 alphanumeric characters.");
      return;
    }
    let updateUserReq = updatedUser;
    api
      .post("/auth/create", updateUserReq)
      .then((response) => {
        if (response.data.statusCodeValue === 200) {
          toast.success("User successfully added.");
          setOpenConfigurator(false);
          setUpdatedUser({
            firstName: "",
            lastName: "",
            mobileNo: "",
            emailId: "",
            dept: "",
            userId: "",
            countryCode: process.env.REACT_APP_COUNTRY_CODE || "91",
            role: "",
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          toast.error("You do not have permission to perform this action.");
          return;
        }
        console.log(error.response);
        toast.error(error.response.data.body);
      });
    console.log(updateUserReq);
  };

  const isValidUserId = /^[A-Za-z0-9]{1,9}$/.test(updatedUser?.userId);

  return (
    <ConfiguratorRoot variant="permanent" ownerState={{ openConfigurator }} configuratorwidth={500}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        pt={4}
        pb={0.5}
        px={3}
      >
        <MDBox>
          <MDTypography variant="h5">New User</MDTypography>
          <MDTypography variant="body2" color="text">
            {updatedUser?.userId}
          </MDTypography>
        </MDBox>

        <Icon
          sx={({ typography: { size }, palette: { dark, white } }) => ({
            fontSize: `${size.lg} !important`,
            color: dark.main,
            stroke: "currentColor",
            strokeWidth: "2px",
            cursor: "pointer",
            transform: "translateY(5px)",
          })}
          onClick={() => setOpenConfigurator(false)}
        >
          close
        </Icon>
      </MDBox>
      <Divider />
      <MDBox
        component="form"
        role="form"
        onSubmit={(form) => newUserFormHandler(form)}
        style={{ maxWidth: "480px" }}
      >
        <MDBox mb={2}>
          <MDInput
            type="text"
            label="Username"
            name="username"
            onChange={(e) =>
              setUpdatedUser({ ...updatedUser, userId: e.target.value.toUpperCase() })
            }
            value={updatedUser?.userId}
            pattern="^[A-Za-z0-9]+$"
            title="Please enter alphanumeric characters only."
            success={isValidUserId}
            error={!isValidUserId}
            fullWidth
            required
          />
        </MDBox>
        <MDBox display="flex" justifyContent="space-between" mb={2}>
          <MDBox flex={1} boxSizing={"border-box"} mr={1}>
            <MDInput
              type="text"
              label="First Name"
              name="first_name"
              onChange={(e) => setUpdatedUser({ ...updatedUser, firstName: e.target.value })}
              value={updatedUser?.firstName}
              fullWidth
              required
            />
          </MDBox>
          <MDBox flex={1} boxSizing={"border-box"}>
            <MDInput
              type="text"
              label="Last Name"
              name="last_name"
              onChange={(e) => setUpdatedUser({ ...updatedUser, lastName: e.target.value })}
              value={updatedUser?.lastName}
              fullWidth
              required
            />
          </MDBox>
        </MDBox>
        <MDBox display="flex" justifyContent="space-between" mb={2}>
          <MDBox flex={4} boxSizing={"border-box"} mr={1}>
            <MDInput
              type="email"
              label="Email"
              name="email"
              onChange={(e) => setUpdatedUser({ ...updatedUser, emailId: e.target.value })}
              value={updatedUser?.emailId}
              fullWidth
              required
            />
          </MDBox>
          <MDBox flex={1} boxSizing={"border-box"}>
            <FormControl fullWidth style={{ height: "100%" }}>
              <InputLabel id="label-role">Select User Role</InputLabel>
              <Select
                labelId="label-role"
                id="label-role"
                label="Select User Role"
                fullWidth
                style={{ height: "100%" }}
                name="role"
                onChange={(e) => setUpdatedUser({ ...updatedUser, role: e.target.value })}
                value={updatedUser?.role}
              >
                <MenuItem value="">-Select user level-</MenuItem>
                <MenuItem value="MAKER">Admin</MenuItem>
                <MenuItem value="ADMIN">Admin</MenuItem>
                <MenuItem value="G_ADMIN">Guest/Viewer</MenuItem>
              </Select>
            </FormControl>
            {/* <MDInput type="text" label="Role" name="role" value={user.role === "ADMIN" ? 'MAKER' : user.role === "SUPERADMIN" ? 'ADMIN' : ''} fullWidth disabled /> */}
          </MDBox>
        </MDBox>
        <MDBox display="flex" justifyContent="space-between" mb={2}>
          <MDInput
            type="tel"
            label="Mobile No"
            name="mobileNo"
            onChange={(e) => {
              const inputValue = e.target.value.slice(0, 10); // Limit to the first 10 characters
              setUpdatedUser({ ...updatedUser, mobileNo: inputValue });
            }}
            value={updatedUser?.mobileNo}
            fullWidth
            required
          />
          <MDBox flex={1} boxSizing={"border-box"}>
            <MDInput
              type="text"
              label="Department"
              name="dept"
              onChange={(e) => setUpdatedUser({ ...updatedUser, dept: e.target.value })}
              value={updatedUser?.dept}
              fullWidth
              required
            />
          </MDBox>
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="password"
            label="Password"
            name="password"
            onChange={(e) => setUpdatedUser({ ...updatedUser, password: e.target.value })}
            fullWidth
            required
          />
        </MDBox>

        <MDBox mt={4} mb={1}>
          <MDButton type="submit" variant="gradient" color="info" style={{ float: "right" }}>
            Add
          </MDButton>
        </MDBox>
      </MDBox>
    </ConfiguratorRoot>
  );
}

NewUser.defaultProps = {
  openConfigurator: false,
  setOpenConfigurator: false,
};

NewUser.propTypes = {
  openConfigurator: PropTypes.bool,
  setOpenConfigurator: PropTypes.func,
};

export default NewUser;
